// extracted by mini-css-extract-plugin
export default {"root":"AddTimeFloatBtn_root__9xIV2","appearance":"AddTimeFloatBtn_appearance__3WJOm"};